import {
    SET_SOUNDOFFS,
    LIKE_SOUNDOFF,
    UNLIKE_SOUNDOFF,
    LOADING_DATA,
    DELETE_SOUNDOFF,
    POST_SOUNDOFF,
    SUBMIT_COMMENT,
    SET_SOUNDOFF
} from '../types';

const initialState = {
    soundOffs: [],
    soundOff: {},
    loading: false
};

export default function (state = initialState, action) {
    let comments;
    switch (action.type) {
        case LOADING_DATA:
            return {
                ...state,
                loading: true
            };
        case SET_SOUNDOFFS:
            return {
                ...state,
                soundOffs: action.payload,
                loading: false
            };
        case SET_SOUNDOFF:
            return {
                ...state,
                soundOff: action.payload
            };
        case LIKE_SOUNDOFF:
            let index = state.soundOffs.findIndex(
                (soundOff) => {
                    console.log(soundOff.soundOffId);
                    console.log(action.payload);
                    return (soundOff.soundOffId === action.payload.soundOffId)
                }
            );

            if (state.soundOff.comments) {
                comments = state.soundOff.comments
            }
            state.soundOffs[index] = action.payload;
            if (state.soundOff.soundOffId === action.payload.soundOffId) {
                state.soundOff = action.payload;
                state.soundOff.comments = comments;
            }
            return {
                ...state
            };
        case UNLIKE_SOUNDOFF:
            let secondIndex = state.soundOffs.findIndex(
                (soundOff) => {

                    return (soundOff.soundOffId === action.payload.soundOffData.soundOffId)
                }
            );

            if (state.soundOff.comments) {
                comments = state.soundOff.comments
            }

            state.soundOffs[secondIndex] = action.payload.soundOffData;
            state.soundOffs[secondIndex].unLiked = true;
            if (state.soundOff.soundOffId === action.payload.soundOffData.soundOffId) {
                state.soundOff = action.payload.soundOffData;
                state.soundOff.comments = comments;
            }
            return {
                ...state
            };

        case DELETE_SOUNDOFF:
            let deleteIndex = state.soundOffs.findIndex(
                (soundOff) => soundOff.soundOffId === action.payload
            );
            state.soundOffs.splice(deleteIndex, 1);
            return {
                ...state
            };
        case POST_SOUNDOFF:
            console.log(action.payload)
            return {
                ...state,
                soundOffs: [action.payload, ...state.soundOffs]
            };
        case SUBMIT_COMMENT:
            return {
                ...state,
                soundOff: {
                    ...state.soundOff,
                    comments: [action.payload, ...state.soundOff.comments]
                }
            };
        default:
            return state;
    }
}